import dayjs from "dayjs";
import { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getValueFromInputCheck } from "../../../components/funcForInput";
import { reqPostDownloadFile, ApiEndpoints } from "../../../config/apiClient";
import stylesCheckbox from "../../colaborador/styles/colaborador.module.css";

export default function RelatorioDownload({ comunicado }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);

    async function downloadRelatorio() {
        const dados = {
            id_comunicado: comunicado.id_comunicado,
            apenas_acesso_permitido: getValueFromInputCheck("relatorio_apenas_com_acesso") === true ? 1 : 0,
            formato: "excel",
        };
        const data_atual = dayjs().format("DD-MM-YYYY");
        const filename = `${comunicado.titulo} ${data_atual}.xlsx`;

        setLoading(true);
        const api = await reqPostDownloadFile(ApiEndpoints.comunicadoRelatorioVisualizacoes, dados, filename);
        if (api.status === 200) {
            toast.success("Download realizado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        } else {
            toast.error("Erro ao baixar relatório, verifique com o suporte!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
        setLoading(false);
    }

    return (
        <div>
            <br></br>
            <div className="div-row">
                {loading && <Spinner style={{ marginRight: "10px" }} />}
                <Button onClick={() => downloadRelatorio()} disabled={loading} style={{ marginRight: "10px" }}>
                    Baixar Relatório
                </Button>
                <Form.Check type="switch" id="relatorio_apenas_com_acesso" label="Apenas colaboradores com acesso permitido?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
            </div>
        </div>
    );
}
interface iProps {
    comunicado: any;
}
